// Fields
export const FIRST_NAME_FIELD = 'first-name';
export const MIDDLE_NAME_FIELD = 'middle-name';
export const LAST_NAME_FIELD = 'last-name';
export const SUFFIX_FIELD = 'suffix';
export const KNOWN_TRAVELER_NUMBER_FIELD = 'known-traveler-number';
export const REDRESS_NUMBER_FIELD = 'redress-number';
export const PASSPORT = 'passport';
export const EMERGENCY_CONTACT = 'emergency contact';
// export const ALLEGIANT_NUMBER_FIELD = 'allegiant-number'; // to be added back when loyalty program is further along
export const DOB_DAY_FIELD = 'dob-day';
export const DOB_MONTH_FIELD = 'dob-month';
export const DOB_YEAR_FIELD = 'dob-year';
export const DOB_FULL = 'dob-full';
export const GENDER_FIELD = 'gender';
export const EMAIL_FIELD = 'email';
export const PRIMARY_PHONE_PREFIX_FIELD = 'primary-phone-prefix';
export const PRIMARY_PHONE_NUMBER_FIELD = 'primary-phone-number';
export const SELECT_NATIONALITY = 'select-nationality';
export const RESIDENCE_PERMIT = 'residence-permit';
export const EMERGENCY_CONTACT_FIRST_NAME_FIELD =
  'emergency-contacts-first-name';
export const EMERGENCY_CONTACT_LAST_NAME_FIELD = 'emergency-contacts-last-name';
export const EMERGENCY_CONTACT_PHONE_PREFIX_FIELD =
  'emergency-contacts-phone-prefix';
export const EMERGENCY_CONTACT_PHONE_NUMBER_FIELD =
  'emergency-contacts-phone-number';
export const PASSPORT_NUMBER_FIELD = 'passport-number';
export const PASSPORT_ISSUING_COUNTRY = 'issuing-country';
export const PASSPORT_EXP_DAY_FIELD = 'exp-day';
export const PASSPORT_EXP_MONTH_FIELD = 'exp-month';
export const PASSPORT_EXP_YEAR_FIELD = 'exp-year';
export const PASSPORT_EXPIRY_FULL = 'expiry-full';
// Other
export const NEXT_TRAVELER_BUTTON = 'next-traveler-button';
export const EDIT_TRAVELER_BUTTON = 'edit-traveler-button';
export const KNOWN_TRAVELER_REDRESS_NUMBER_SECTION =
  'known-traveler-redress-section';
export const TRAVEL_DOCUMENT_SECTION = 'travel-document-section';
export const SSRS_SECTION = 'ssrs-section';
export const DESIGNATED_LAP_FIELD = 'designated-lap';
export const SAVED_TRAVELER_FIELD = 'saved-traveler';
export const SAVE_AS_SAVED_TRAVELER = 'save-as-saved-traveler';
export const DEPARTING_SSRS = 'departing';
export const RETURNING_SSRS = 'returning';
export const TRAVELER_INDEX = 'traveler-index';

// SSRS

export const SAME_SSR_OPTIONS_FOR_BOTH_FLIGHTS = 'same-ssr-options';
